import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                桃子视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              桃子视频🎯数字系列视频平台，91视频、97视频、📌51视频等热门资源免费高清在线看，电视剧电影全集不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快捷链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                contact@taozivideo.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-line text-sm"></i>
                </div>
                在线客服 7×24小时
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                中国·北京
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; 2024 桃子视频 Taozivideo.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}